import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { Link, useLocation } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Outlet } from "react-router-dom";
import ProtectedRoute from "../ProtectedRoute";
import RoleBasedMenu from "./RoleBasedMenuItems";
import { LogOut } from "lucide-react";
import {
	contentProviderMenuItems,
	adminMenuItems,
	advertProviderMenuItems,
} from "../../utils/roleBasedMenuItems";
import { clearContentForm } from "../../redux/slices/contentSlice/contentForm/contentForm";
import { handleReset } from "../../redux/slices/addNewContentStepsSlice";
import { handleFilePicked } from "../../redux/slices/contentSlice/onedriveContent/onedriveContent";
import { resetAgreementForm } from "../../redux/slices/agreementFormSlice";
import { useEffect } from "react";

const drawerWidth = 250;

const AppBar = styled(MuiAppBar, {
	shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
	transition: theme.transitions.create(["margin", "width"], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	...(open && {
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["margin", "width"], {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen,
		}),
		marginRight: drawerWidth,
	}),
}));

export default function PersistentDrawerLeft({ handleSignOut }) {
	const user = useSelector((state) => state.auth.user);
	const dispatch = useDispatch();
	const location = useLocation();

	const storedGroups = JSON.parse(
		localStorage.getItem("loggedInUserGroups") || "[]"
	);

	let menuItems;
	if (user.role === "ContentProviders") {
		menuItems = contentProviderMenuItems;
	} else if (user.role === "AdvertProvider") {
		menuItems = advertProviderMenuItems;
	} else {
		menuItems = adminMenuItems;
	}

	// useEffect(() => {
	// 	// Reset Redux state whenever the location changes
	// 	dispatch(clearContentForm());
	// 	dispatch(resetAgreementForm());
	// 	dispatch(handleFilePicked(false));
	// 	dispatch(handleReset());
	// }, [location, dispatch]);

	return (
		<Box sx={{ display: "flex" }}>
			<CssBaseline />
			<AppBar
				position="fixed"
				sx={{
					width: `calc(100% - ${drawerWidth}px)`,
					ml: `${drawerWidth}px`,
					background: "white",
					borderBottom: "1px solid lightgrey",
					color: "black",
					padding: 2,
				}}
			>
				<Toolbar sx={{ justifyContent: "space-between" }}>
					<Box>
						<Typography
							variant="h6"
							component="div"
							sx={{ flexGrow: 1 }}
						>
							{user?.attributes?.["custom:name"]}
						</Typography>
						<Typography
							variant="p"
							component="div"
							sx={{ flexGrow: 1 }}
						>
							{moment().format("dddd, MMMM D, YYYY")}
						</Typography>
					</Box>
					<Box>
						<Button
							onClick={handleSignOut}
							sx={{ gap: 2, textTransform: "capitalize" }}
						>
							<LogOut />
							Log Out
						</Button>
					</Box>
				</Toolbar>
			</AppBar>
			<Drawer
				sx={{
					width: drawerWidth,
					flexShrink: 0,
					"& .MuiDrawer-paper": {
						width: drawerWidth,
						boxSizing: "border-box",
						backgroundColor: "black",
						py: "10px",
					},
				}}
				variant="permanent"
				anchor="left"
			>
				<Toolbar>
					<Box
						display={"flex"}
						alignItems={"center"}
						justifyContent={"center"}
						sx={{ flexGrow: 1 }}
					>
						<Link
							style={{
								display: "flex",
								alignItems: "center",
								gap: "4px",
								textDecoration: "none",
							}}
							to={"/"}
						>
							<img
								src="/assets/DreamStreamLogo.svg"
								alt=""
								height={50}
							/>
						</Link>
					</Box>
				</Toolbar>
				<Toolbar>
					<Box
						display={"flex"}
						alignItems={"center"}
						sx={{
							flexGrow: 1,
							color: "#FFE300",
							my: 4,
							paddingBottom: 2,
							borderBottom: "2px solid",
						}}
						gap={2}
					>
						<Avatar>
							{user?.attributes?.["custom:name"]?.slice(0, 1)}
						</Avatar>
						<Box>
							<Typography>
								{user?.attributes?.["custom:name"]}
							</Typography>
							<Typography fontSize={12}>
								{user?.role === "Admin"
									? "Admin"
									: "Content Provider"}
							</Typography>
						</Box>
					</Box>
				</Toolbar>
				<Divider />
				<RoleBasedMenu menuItems={menuItems} />
			</Drawer>
			<Box
				component="main"
				sx={{ flexGrow: 1, bgcolor: "background.default", p: 3 }}
			>
				<Toolbar />
				<Toolbar sx={{ minHeight: "25px !important" }} />
				<ProtectedRoute>
					<Outlet />
				</ProtectedRoute>
			</Box>
		</Box>
	);
}
